import { updateAppVersionFn } from 'api'
import { useMutation, useQueryClient } from 'react-query'
import { toast } from 'react-toastify'
import { useTranslation } from 'react-i18next'

export function useUpdateApplication() {
  const [t] = useTranslation()
  const queryClient = useQueryClient()

  return useMutation(updateAppVersionFn, {
    onError: () => {
      toast.error(t(`error.default`))
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['app-versions'] })
      toast.success(t('modal.editAppVersion.success'))
    },
  })
}